export var TrainingSessionStatsMode;
(function (TrainingSessionStatsMode) {
    TrainingSessionStatsMode["week"] = "week";
    TrainingSessionStatsMode["month"] = "month";
    TrainingSessionStatsMode["total"] = "total";
})(TrainingSessionStatsMode || (TrainingSessionStatsMode = {}));
export const getTrainingSessionStatsModeDescription = (mode) => {
    switch (mode) {
        case TrainingSessionStatsMode.week:
            return 'wöchentlich';
        case TrainingSessionStatsMode.month:
            return 'monatlich';
        case TrainingSessionStatsMode.total:
            return 'gesamt';
    }
};
//# sourceMappingURL=training-session-stats-mode.enum.js.map